import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import EventListSection from "../../../components/NewDesign/Event/EventListSection";
import { Tab, Tabs } from "react-bootstrap";
import useLogin from "../../../custom-hooks/useLogin";
import EventsCalendar from "../../../components/Calendar/EventsCalendar";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { routeList } from "../../../utils/routeList";
import ManageGroupWorkshop from "../../../components/GroupWorkshop/ManageGroupWorkshop";

const LearnMCSessionPage = ({ isEvents }) => {
  const [key, setKey] = useState("upComingEvents");
  const navigate = useNavigate();
  const { isLoggedIn } = useLogin();
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0);
  const { t } = useTranslation();
  const userRole = useSelector((state) => state.user.role);
  const [changekey, setChangeKey] = useState("tab1");
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const [loading, setLoading] = useState(false);
  const tab = params.get("tab");
  // useEffect(() => {
  //   console.log("tab", tab);
  //   if (tab === "1") {
  //     setChangeKey("tab1");
  //   } else if (tab === "2") {
  //     setChangeKey("tab2");
  //   } 
  //   // else if (tab === "3") {
  //   //   setKey("tab3");
  //   // } else if (tab === "4") {
  //   //   setKey("tab4");
  //   // } else if (tab === "5") {
  //   //   setKey("tab5");
  //   // }
  // }, [tab]);
  useEffect(() => {
    if(tab === "1"){
    setChangeKey("tab1");
    }
  }, [tab]);
  useEffect(() => {
    return () => {
      setKey("upComingEvents");
    };
  }, []);
  const handleTabChange = (tabKey) => {
    setLoading(true); // Activate loader
    setChangeKey(tabKey); 
  };
  return (
    <>
      {changekey === "tab1" ? (
         <div className="contsection">
         {/* <Tabs
           underline
           activeKey={key}
           onSelect={(k) => {
             // setIsFetching(true)
             console.log("selectKey: ", k);
             setKey(k);
 
           }}
         >
           <Tab eventKey={"upComingEvents"} title="Gruop Workshop">
               
           </Tab>
           {isLoggedIn && false && (
             <Tab eventKey={"myEvents"} title="My sessions">
               
             </Tab>
           )}
         </Tabs> */}
         <div className="d-flex justify-content-between align-items-center">
           <h3 className="mentor-title mb-0">
             {isEvents ? t("Events") : t("Masterclass")}
           </h3>
           {userRole === "manager" && !isEvents &&  false && (
             <Link to="/create-group-workshop">
               <button   className="btn-primary active-page d-flex align-items-center gap-2">
                 <svg
                   xmlns="http://www.w3.org/2000/svg"
                   width="24"
                   height="24"
                   viewBox="0 0 24 24"
                   fill="none"
                 >
                   <path
                     d="M11 10.9996V2.00001L13 2V10.9996L22.0001 10.9994L22.0002 12.9994L13 12.9996L13.0001 21.9995H11.0001V12.9996L2.00004 12.9998L2 10.9998L11 10.9996Z"
                     fill="white"
                   />
                 </svg>
                 {t("createGroupWorkshop")}
               </button>
             </Link>
           )}
           { true && userRole === "manager" && !isEvents && (
             <Link to={routeList.MANAGE_WORKSHOP_LISTING}>
               <button   onClick={() => {
                // navigate(routeList.MANAGE_WORKSHOP_LISTING)
                //  handleTabChange("tab2")
               }} className="btn-primary active-page d-flex align-items-center gap-2">
                 {/* <svg
                   xmlns="http://www.w3.org/2000/svg"
                   width="24"
                   height="24"
                   viewBox="0 0 24 24"
                   fill="none"
                 >
                   <path
                     d="M11 10.9996V2.00001L13 2V10.9996L22.0001 10.9994L22.0002 12.9994L13 12.9996L13.0001 21.9995H11.0001V12.9996L2.00004 12.9998L2 10.9998L11 10.9996Z"
                     fill="white"
                   />
                 </svg> */}
                 {t("manageWorkshop")}
               </button>
             </Link>
           )}
         </div>
         {key === "upComingEvents" ? (
           <EventsCalendar
             isHome={false}
             isLearn={true}
             marketingDateRange={null}
             setSelectedSessionFromHome={setSelectedSessionFromHome}
             selectedSessionPos={selectedSessionPos}
             setSelectedSessionPos={setSelectedSessionPos}
             isEvents={isEvents}
           />
         ) : (
           <EventListSection />
         )}
       </div>
      ) : changekey === "tab2" ? (
        <ManageGroupWorkshop setLoading={setLoading} loading={loading} />
      ) 
      : (
        ""
      )}
      {false && <div className="contsection">
        {/* <Tabs
          underline
          activeKey={key}
          onSelect={(k) => {
            // setIsFetching(true)
            console.log("selectKey: ", k);
            setKey(k);

          }}
        >
          <Tab eventKey={"upComingEvents"} title="Gruop Workshop">
              
          </Tab>
          {isLoggedIn && false && (
            <Tab eventKey={"myEvents"} title="My sessions">
              
            </Tab>
          )}
        </Tabs> */}
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mentor-title mb-0">
            {isEvents ? t("Events") : t("groupWorkshop")}
          </h3>
          {userRole === "manager" && !isEvents &&  false && (
            <Link to="/create-group-workshop">
              <button className="btn-primary active-page d-flex align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 10.9996V2.00001L13 2V10.9996L22.0001 10.9994L22.0002 12.9994L13 12.9996L13.0001 21.9995H11.0001V12.9996L2.00004 12.9998L2 10.9998L11 10.9996Z"
                    fill="white"
                  />
                </svg>
                {t("createGroupWorkshop")}
              </button>
            </Link>
          )}
          { true && userRole === "manager" && !isEvents && (
            <Link to={routeList.MANAGE_WORKSHOP_LISTING}>
              <button className="btn-primary active-page d-flex align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 10.9996V2.00001L13 2V10.9996L22.0001 10.9994L22.0002 12.9994L13 12.9996L13.0001 21.9995H11.0001V12.9996L2.00004 12.9998L2 10.9998L11 10.9996Z"
                    fill="white"
                  />
                </svg>
                {t("Manage workshop")}
              </button>
            </Link>
          )}
        </div>
        {key === "upComingEvents" ? (
          <EventsCalendar
            isHome={false}
            isLearn={true}
            marketingDateRange={null}
            setSelectedSessionFromHome={setSelectedSessionFromHome}
            selectedSessionPos={selectedSessionPos}
            setSelectedSessionPos={setSelectedSessionPos}
            isEvents={isEvents}
          />
        ) : (
          <EventListSection />
        )}
      </div>}
    </>
  );
};

export default LearnMCSessionPage;
